<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <template slot="header">
            <div class="row">
              <div class="col-6">
                <h3 class="mb-0">Autorizaciones</h3>
              </div>
              <div class="col-6 text-right">
                <base-button class="hover-apolo" type="default" icon size="sm" @click="generateToken()">
                  <span class="btn-inner--icon"
                    ><i class="fas fa-plus"></i
                  ></span>
                  <span class="btn-inner--text">Generar Token</span>
                </base-button>
              </div>
            </div>
          </template>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
            <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Datos por página"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item.value"
                  :label="item.descripcion"
                  :value="Number(item.value)"
                >
                </el-option>
            </el-select>
  
              <div>
                <form class="apolo-borde">
                  <base-input
                    v-model="query"
                    type="search"
                    append-icon="fas fa-search"
                    placeholder="Buscar..."
                    clearable
                    inputClasses="apolo-borde"
                  />
                </form>
              </div>
            </div>
            <el-table
              class="table-responsive align-items-center table-flush"
              header-row-class-name="thead-light"
              :data="tokens"
              @sort-change="sortChange"
            >
              <div slot="empty" v-if="loading">
                <img src="/img/loading.gif" style="height: 100px; width: 100px" />
              </div>

              <div slot="empty" v-if="tokens">
                Sin datos disponibles
              </div>
  
              <el-table-column label="Token" prop="attributes.token" />
              <el-table-column label="Descripción">
                <div slot-scope="{ row }">
                  <span v-if="row.attributes.descripcion === null">Ninguna</span>
                  <span v-else>{{row.attributes.descripcion}}</span>
                </div>
              </el-table-column>
              <el-table-column label="Estatus">
                <div slot-scope="{ row }">
                  <span v-if="row.attributes.status === 0">Vigente</span>
                  <span v-if="row.attributes.status === 1">Consumido</span>
                  <span v-if="row.attributes.status === 2">Vencido</span>
                </div>
              </el-table-column>
              <el-table-column label="Creado por">
                <div slot-scope="{ row }">
                  <span>{{ row.attributes.name +' '+ row.attributes.last_name }}</span>
                </div>
              </el-table-column>
              <el-table-column label="Fecha creación">
                <div slot-scope="{ row }">
                  <span>{{row.attributes.fecha_creado | moment('DD-MM-YYYY, HH:mm')}} Hrs</span>
                </div>
              </el-table-column>
              <el-table-column label="Fecha usado">
                <div slot-scope="{ row }">
                  <span v-if="row.attributes.fecha_usado === null">Sin usar</span>
                  <span v-else>{{row.attributes.fecha_usado | moment('DD-MM-YYYY, HH:mm')}} Hrs</span>
                </div>
              </el-table-column>
              <el-table-column label="# Boleto">
                <div slot-scope="{ row }">
                  <span v-if="row.attributes.boleto_id === null && row.attributes.fecha_usado === null">Sin usar</span>
                  <span v-if="row.attributes.boleto_id === null && row.attributes.fecha_usado != null">No disponible</span>
                  <span v-else>{{row.attributes.boleto_id}}</span>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center flex-wrap"
          >
           <!--<div class="">
              <p class="card-category">
                Mostrando {{ total ? from + 1 : 0 }} a {{ to }} de
                {{ total }} entradas
  
                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{ selectedRows.length }} filas seleccionadas
                </span>
              </p>
            </div>
            --> 
            <base-pagination
              class="pagination-no-border justify-content-right"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            />
          </div>
        </card>
      </div>
    </div>

    <modal :show.sync="showToken" modal-classes="modal-primary">
      <h6 slot="header" class="mb-0 modal-title">Token para autorizaciones</h6>
      <form class="new-event--form" @submit.prevent="">
        <h2>El token generado es el siguiente: <strong> {{ token }} </strong></h2>
        <input type="hidden" class="new-event--start"/>
        <input type="hidden" class="new-event--end"/>
      </form>
      <template slot="footer">
        <a type="button" class="btn btn-primary hover-apolo ml-auto" :href="'https://api.whatsapp.com/send?text='+ this.token.toString() " target="_blank" style="background-color: #0068a1 !important; color: white;">Compartir token por whatsapp</a>
        <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="close()">Cerrar</button>
      </template>
    </modal>
  </div>
  
</template>
<script>
import formMixin from "@/mixins/form-mixin";
import { BasePagination, Modal } from "@/components/";
  import {
    Table,
    TableColumn,
    DropdownMenu,
    DropdownItem,
    Dropdown,
    Tooltip,
    Select,
    Option,
    RadioButton,
    Button,
  } from "element-ui";

export default {
  layout: "DashboardLayout",

  mixins: [formMixin],

  components: {
      BasePagination,
      [Tooltip.name]: Tooltip,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Select.name]: Select,
      [Option.name]: Option,
      [Button.name]: Button,
    },

  data() {
    return {
      tokens: [],
      token: "",
      showToken: false,

      selectedRows: [],
      query: null,
      sort: "created_at",
  
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [{value:'5', descripcion: '5 tokens por página'},
          {value:'10', descripcion: '10 tokens por página'},
          {value:'25', descripcion: '25 tokens por página'},
          {value:'50', descripcion: '50 tokens por página'}],
        },
        total: 0,
        loading: true,
    };
  },
  created() {
    //this.getTokens();
  },

  computed: {
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
      },
  
      to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
    },

    watch: {
      query: {
        handler: "getListDebounced",
        immediate: true,
      },
      pagination: {
        handler: "getList",
        immediate: false,
        deep: true,
      },
    },

  methods: {
    close(){
      this.token = "";
      this.showToken = false; 
    },  
    async generateToken() {
      try{
        await this.$store.dispatch("autorizaciones/token");
        const token = await { ...this.$store.getters["autorizaciones/token"] };
        this.token = token.result.token;
        this.showToken = true;
      }catch (error){
        if (error.response.data.errors[0]) {
            this.$notify({
                type: "danger",
                message: error.response.data.errors[0].detail,
                duration: -1
            });
        } else {
            this.$notify({
                type: "danger",
                message: "Oops, ha ocurrido un problema!",
                duration: -1
            });
        }
      }
    },

    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),

    async getList() {
      let params = {
        ...(this.sort ? { sort: this.sort } : {}),
        filter: {
          ...(this.query ? { token: this.query } : {}),
        },
        page: {
          number: this.pagination.currentPage,
          size: this.pagination.perPage,
        },
      };

      await this.$store.dispatch("autorizaciones/list", params).then(() => {
        this.tokens = this.$store.getters["autorizaciones/list"];
        this.total = this.$store.getters["autorizaciones/listTotal"];
      });
      this.loading = false;
    },
    sortChange({ prop, order }) {
        if (order === "descending") {
          this.sort = `-${prop}`;
        } else {
          this.sort = `${prop}`;
        }
        this.getList();
      },
  },
};
</script>